"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_icons_1 = require("@carvana/helios-icons");
var helios_navigation_1 = require("@carvana/helios-navigation");
var helios_styles_1 = require("@carvana/helios-styles");
var react_1 = require("react");
var SearchResults_1 = require("./SearchResults");
var styles_1 = require("./styles");
var useOutsideClickRef_1 = __importDefault(require("./useOutsideClickRef"));
var Search = function (_a) {
    var placeholder = _a.placeholder, showSubmit = _a.showSubmit, _b = _a.recents, recents = _b === void 0 ? [] : _b, _c = _a.suggestions, suggestions = _c === void 0 ? [] : _c, onChange = _a.onChange, onSearch = _a.onSearch, _d = _a.onClearRecent, onClearRecent = _d === void 0 ? function () { } : _d, _e = _a.onClearAllRecent, onClearAllRecent = _e === void 0 ? function () { } : _e, onClearInput = _a.onClearInput, _f = _a.value, value = _f === void 0 ? '' : _f, _g = _a.size, size = _g === void 0 ? 'md' : _g, _h = _a.disabled, disabled = _h === void 0 ? false : _h;
    var _j = (0, react_1.useState)(false), isOpen = _j[0], setIsOpen = _j[1];
    var outsideClickRef = (0, useOutsideClickRef_1.default)(function () { return setIsOpen(false); });
    var resultsContainerRef = (0, react_1.useRef)();
    var onInputChange = function (e) {
        if (onChange) {
            onChange(e.target.value);
        }
        if (!isOpen) {
            setIsOpen(true);
        }
    };
    var selectOption = function (text) {
        onChange(text);
        onSearch(text);
        setIsOpen(false);
    };
    var handleKeyDown = function (event) {
        if (event.code === 'Enter') {
            event.preventDefault();
            event.target.click(event);
        }
        else if (event.code === 'Escape') {
            setIsOpen(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ ref: outsideClickRef, "$size": size }, { children: [(0, jsx_runtime_1.jsxs)(styles_1.SearchWrapper, { children: [(0, jsx_runtime_1.jsxs)(styles_1.SearchBox, __assign({ "$disabled": disabled, "$hasValue": value }, { children: [(0, jsx_runtime_1.jsx)(helios_icons_1.Search, { color: disabled ? helios_styles_1.icon.disabled : helios_styles_1.icon.default }), (0, jsx_runtime_1.jsx)(styles_1.Input, { value: value, placeholder: placeholder, onChange: function (e) { return onInputChange(e); }, onKeyDown: function (e) {
                                    if (e.code === 'Enter') {
                                        onSearch(value);
                                        setIsOpen(false);
                                    }
                                }, disabled: disabled }), (0, jsx_runtime_1.jsx)(styles_1.CloseButton, __assign({ onClick: onClearInput, className: "helios-search-close", type: "button" }, { children: (0, jsx_runtime_1.jsx)(helios_icons_1.XIcon, {}) }))] })), isOpen && ((0, jsx_runtime_1.jsx)(SearchResults_1.SearchResults, { reference: resultsContainerRef, onKeyDown: handleKeyDown, onClick: selectOption, recents: recents, suggestions: suggestions, onClearRecent: onClearRecent, onClearAllRecent: onClearAllRecent, value: value, size: size }))] }), showSubmit && ((0, jsx_runtime_1.jsx)(helios_navigation_1.Button, __assign({ size: "md", utility: true, disabled: disabled, onClick: function () {
                    onSearch(value);
                    setIsOpen(false);
                } }, { children: "Go" })))] })));
};
exports.Search = Search;
